import angular from 'angular';
import { RegistrationGroup } from './model/registrationGroup';
import { Registration } from './model/registration';
import { castJSON } from '../helpers';
import moment from 'moment';
import { sanitizeReferenceYear } from '@/shared/components/registration/registrationHelpers';

angular
  .module('cxRegistrations')
  .controller('RegDayCtrl', [
    '$filter',
    'resourceFactorySvc',
    'registrationService',
    'flySvc',
    'dialogsSvc',
    '$window',
    'dataCache',
    '$q',
    'regDialogsSvc',
    '$http',
    'appUrls',
    'localStorageService',
    'checkSecurity',
    'checkFeature',
    dayCtrl,
  ]);

function dayCtrl(
  $filter,
  resourceFactorySvc,
  registrationService,
  flySvc,
  dialogsSvc,
  $window,
  dataCache,
  $q,
  regDialogsSvc,
  $http,
  appUrls,
  localStorageService,
  checkSecurity,
  checkFeature,
) {
  var registrationResource = resourceFactorySvc.get('registration');
  var vm = this;
  vm.registrationService = registrationService;
  vm.date = moment()
    .local()
    .toDate();
  vm.filterBillable = false;
  vm.isBusy = false;
  vm.registration = null;
  vm.registrations = [];
  vm.startTime = null;
  var sortStorageKey = 'cx-registration-day-sort-desc';
  var displayDetailsStorageKey = 'cx-registration-day-show-details';

  vm.sortDesc = localStorageService.get(sortStorageKey) || false;
  vm.expectedWorkingMinutes = null;
  vm.homeWorkingMinutes = null;
  vm.overtimeMinutes = null;
  vm.currentUser = dataCache.getArray('employee');
  vm.taskStatusCache = {};
  vm.displayDetails = localStorageService.get(displayDetailsStorageKey) || false;
  vm.hasTrainingFeature = checkFeature('Training');

  vm.getTotalHours = function() {
    if (!vm.registrations) return 0;
    return vm.registrations.reduce(function(sum, reg) {
      if (reg && reg.work) return sum + reg.work.durationMinutes;
      return sum;
    }, 0.0);
  };
  vm.getMissingHours = function() {
    if (vm.expectedWorkingMinutes === null) return null;
    return Math.max(0, vm.expectedWorkingMinutes - vm.getTotalHours());
  };

  // Update sorted registrations - called when data or sort order changes
  var sortRegistrations = function() {
    if (!vm.registrations || vm.registrations.length === 0) {
      return;
    }

    vm.registrations = vm.registrations.slice().sort(function(a, b) {
      // First sort by hasWork (items with work should come first)
      var aHasWork = a.hasWork ? 1 : 0;
      var bHasWork = b.hasWork ? 1 : 0;
      if (aHasWork !== bHasWork) {
        return bHasWork - aHasWork; // Descending (items with work first)
      }

      // Then sort by time (fromMinutes)
      var aTime = (a.work && a.work.fromMinutes) || 0;
      var bTime = (b.work && b.work.fromMinutes) || 0;
      if (aTime !== bTime) {
        return vm.sortDesc ? bTime - aTime : aTime - bTime;
      }

      // Finally sort by relation name
      var aName = (a.relation && a.relation.name) || '';
      var bName = (b.relation && b.relation.name) || '';
      return aName.localeCompare(bName);
    });
  };

  vm.changeSorting = function() {
    vm.sortDesc = !vm.sortDesc;
    localStorageService.set(sortStorageKey, vm.sortDesc);
    sortRegistrations();
  };

  //Creates an empty registration
  var createEmptyRegistration = function(startTime) {
    var defered = $q.defer();
    var registration = new RegistrationGroup();
    var durationMinutes = 0; //Set to "0" instead of "15" due to TFS 4717.4730.
    registration.date = vm.date;
    registration.referenceYear = sanitizeReferenceYear(null, vm.date);
    var vat = dataCache.getDefaultCompany().resourceVATRate || 0.21;
    registration.work.setVatRate(vat, 0);
    registration.cost.setVatRate(vat, 0);
    registration.travel.setVatRate(vat, 0);

    if (startTime && typeof startTime.Hour === 'number' && typeof startTime.Minute === 'number') {
      registration.work.initTime(startTime.Hour, startTime.Minute, durationMinutes);
      defered.resolve(registration);
    } else {
      registrationService.getNextRegistrationTime(vm.date).then(function(data) {
        registration.work.initTime(data.Hour, data.Minute, durationMinutes);
        defered.resolve(registration);
      });
    }

    return defered.promise;
  };

  vm.editRegistration = function(registration) {
    if (
      registration &&
      (registration.date.getFullYear() != vm.date.getFullYear() ||
        registration.date.getMonth() != vm.date.getMonth() ||
        registration.date.getDay() != vm.date.getDay())
    )
      return; //In case the user already changed date.
    if (registration && (registration.work.type === 3 || registration.work.type === 4))
      return vm.editAbsence(registration.work);

    if (registration && registration.work.type === 5) {
      return vm.editTraining(registration.work);
    }

    $window.scrollTo(0, 0);
    vm.registration = registration;
    if (vm.registration && vm.registration.group && checkSecurity('InteractionsOwn:r')) {
      $http.get(appUrls.interactions + '/api/interactions/object/1/' + vm.registration.group).then(
        function({ data }) {
          if (data && data.length) {
            const interaction = data[0];
            vm.registration.interactionType = interaction.interactionType;
            vm.registration.interactionDescription = interaction.description;
            vm.registration.interactionId = interaction.id;
            vm.registration.interactionTitle = interaction.title;

            vm.registration.originalInteractionDescription = interaction.description;
            vm.registration.originalInteractionType = interaction.interactionType;
            vm.registration.originalInteractionTitle = interaction.title;
            vm.registration.originalInteraction = interaction;
          }
        },
        function(error) {
          console.error(error);
        },
      );
    }

    if (!vm.registration) {
      createEmptyRegistration().then(function(data) {
        vm.registration = data;
      });
    }
  };

  vm.removeRegistration = function(registration) {
    var index = vm.registrations.indexOf(registration);
    if (index >= 0) vm.registrations.splice(index, 1);
    vm.newRegistration();
  };

  //Retrieve data
  vm.retrieveRequest = null;
  vm.retrieveRegistrations = function(date) {
    vm.registrations = [];
    vm.startTime = null;

    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();

    vm.retrieveRequest = registrationService.retrieveRegistrations(null, date);

    vm.loading = true;

    return vm.retrieveRequest.then(function({ data }) {
      vm.loading = false;

      let {
        registrations,
        maxTime = null,
        expectedWorkingMinutes = null,
        homeWorkingMinutes = null,
        overtimeMinutes = null,
      } = data;
      registrations = registrations.map(x => {
        var reg = castJSON(x, Registration);
        if (reg) {
          reg.translate($filter);
        }
        return reg;
      });

      var groups = registrations.reduce(function(o, v, i) {
        //Group registrations by group.
        if (!o[v.group]) o[v.group] = [];
        o[v.group].push(v);
        return o;
      }, {});

      for (var group in groups) {
        if (groups.hasOwnProperty(group)) {
          vm.registrations.push(registrationService.createGroup(groups[group], date));
        }
      }
      vm.expectedWorkingMinutes = expectedWorkingMinutes;
      vm.homeWorkingMinutes = homeWorkingMinutes;
      vm.overtimeMinutes = overtimeMinutes;
      if (maxTime) {
        const momentDate = moment(maxTime, 'HH:mm:ss');
        var h = momentDate.hour();
        var m = momentDate.minutes();
        vm.startTime = {
          Hour: h,
          Minute: m,
        };
      } else {
        vm.startTime = {
          Hour: 9,
          Minute: 0,
        };
      }
      sortRegistrations();
      vm.retrieveTaskStatus();
      return vm.registrations;
    });
  };
  vm.retrieveRegistrations().then(function() {
    vm.init();
  });

  vm.init = function() {
    vm.newRegistration(vm.startTime);
  };

  vm.dateChanged = function(date) {
    vm.startTime = null;
    vm.date = date;

    vm.retrieveRegistrations(vm.date).then(function() {
      if (vm.registration) {
        if (vm.registration.group) {
          vm.newRegistration(vm.startTime);
        } else {
          vm.registration.date = vm.date;
          if (vm.startTime) {
            vm.registration.work.initTime(
              vm.startTime.Hour,
              vm.startTime.Minute,
              vm.registration.work.durationMinutes,
            );
          } else {
            registrationService.getNextRegistrationTime(vm.date).then(function(data) {
              vm.registration.work.initTime(
                data.Hour,
                data.Minute,
                vm.registration.work.durationMinutes,
              );
            });
          }
        }
      }
    });
  };

  //Create new registration
  vm.newRegistration = function(startTime) {
    var registration = createEmptyRegistration(startTime).then(function(data) {
      vm.editRegistration(data);
    });
  };

  vm.saveReg = function(registration) {
    if (!registration) return $q.reject();

    if (registration.group) {
      vm.isBusy = true;

      return registrationResource
        .update([registration.work, registration.travel, registration.cost])
        .$promise.then(
          data => {
            var group = registrationService.createGroup(data, vm.date);
            group.setInteractionInfo(registration); //Copy interaction info
            group.translate($filter);

            flySvc.success('Registration modified');
            vm.retrieveTaskStatus(false, group.getPlannedTaskId());
            return group;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return error;
          },
        )
        .finally(function() {
          vm.isBusy = false;
        });
    } else {
      return vm.createReg(registration, false);
    }
  };

  vm.createReg = function(registration, editOnFail) {
    registration.date = vm.date;
    vm.isBusy = true;

    return registrationResource
      .save([registration.work, registration.travel, registration.cost])
      .$promise.then(
        function(data) {
          if (data.length) {
            var newReg = registrationService.createGroup(data, vm.date);
            newReg.translate($filter);
            flySvc.proposal(
              'Registration created',
              'msgRegistrationCreated',
              function() {
                vm.editRegistration(newReg);
              },
              'Edit registration',
              null,
              {
                relation: $filter('relationName')(newReg.relation),
                resource: newReg.resourceText,
              },
            );

            if (
              newReg.hasWork &&
              newReg.hasWork &&
              newReg.work.toMinutes != newReg.work.toMinutes
            ) {
              flySvc.message('The end time was truncated');
            }
            return newReg;
          }
          return null;
        },
        function(error) {
          if (editOnFail) {
            vm.editRegistration(registration);
          }

          flySvc.error(error.data.code, error.data.parameters);
        },
      )
      .finally(function() {
        vm.isBusy = false;
      });
  };
  vm.afterSave = function(reg) {
    if (reg) {
      const sameDate = moment(vm.date).isSame(moment(reg.date), 'day');
      const idx = vm.registrations.findIndex(x => x.group === reg.group);
      if (idx >= 0) {
        if (sameDate) {
          //Replace
          vm.registrations[idx] = reg;
          vm.retrieveTaskStatus(false, reg.getPlannedTaskId());
        } else {
          //Moved to other day, remove registration
          vm.registrations.splice(idx, 1);
        }
      } else if (sameDate) {
        //Add
        vm.registrations.push(reg);
        vm.retrieveTaskStatus(false, reg.getPlannedTaskId());
      }
      sortRegistrations();
    }
    vm.editRegistration(null);
    $window.scrollTo(0, 0);
    vm.isBusy = false;
  };
  vm.deleteRegistration = function(registration) {
    return dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteRegistration').then(
      function(result) {
        if (vm.registration === registration) vm.editRegistration(null);

        if (registration.group) {
          vm.isBusy = true;

          registrationResource.delete(
            {
              id: registration.group,
              deleteGroup: true,
            },
            function(response) {
              vm.isBusy = false;
              vm.removeRegistration(registration);
              flySvc.success('Registration removed');
            },
            function(error) {
              vm.isBusy = false;
              flySvc.error(error.data.code, error.data.parameters);
            },
          );
        } else {
          vm.removeRegistration(registration);
        }
        return true;
      },
      function() {
        return false;
      },
    );
  };

  vm.createAbsence = function(type = 3) {
    registrationService.getNextRegistrationTime(vm.date).then(function(data) {
      var absence = new Registration({ type });
      absence.date = vm.date;
      absence.initTime(data.Hour, data.Minute, 0);

      regDialogsSvc.newAbsence(absence, {}).then(function(result) {
        if (result) {
          if (moment(vm.date).isSame(moment(result.date), 'day')) {
            var reg = registrationService.createGroup([result], result.date);
            reg.translate($filter);
            vm.registrations.push(reg);
            $window.scrollTo(0, 0);
          }
        }
      });
    });
  };
  vm.editAbsence = function(absence) {
    var copy = angular.copy(absence);

    regDialogsSvc.editAbsence(copy, {}).then(function(result) {
      if (result) {
        if (moment(vm.date).isSame(moment(result.date), 'day')) {
          absence.set(result);
          absence.translate($filter);
        } else {
          var idx = vm.registrations.findIndex(x => x.group === absence.group);
          if (idx >= 0) vm.registrations.splice(idx, 1);
        }
      }
    });
  };

  vm.createTraining = () => {
    registrationService.getNextRegistrationTime(vm.date).then(function(data) {
      var training = new Registration();
      training.type = 5;
      training.date = vm.date;
      training.initTime(data.Hour, data.Minute, 0);

      regDialogsSvc.newTraining(training, {}).then(result => {
        if (result && moment(vm.date).isSame(moment(result.date), 'day')) {
          const reg = registrationService.createGroup([result], result.date);
          reg.translate($filter);
          vm.registrations.push(reg);

          $window.scrollTo(0, 0);
        }
      });
    });
  };

  vm.editTraining = function(training) {
    var copy = angular.copy(training);

    regDialogsSvc.editTraining(copy, {}).then(function(result) {
      if (result) {
        if (moment(vm.date).isSame(moment(result.date), 'day')) {
          training.set(result);
          training.translate($filter);
        } else {
          var idx = vm.registrations.findIndex(x => x.group === training.group);
          if (idx >= 0) vm.registrations.splice(idx, 1);
        }
      }
    });
  };

  vm.updateHomeWorkingMinutes = function(value) {
    if (value === vm.homeWorkingMinutes) return false;
    return $http
      .post(appUrls.api + '/api/Employee/HomeWorking', {
        userId: vm.currentUser.userID,
        date: vm.date,
        homeWorkingMinutes: value,
      })
      .then(
        function({ data }) {
          vm.homeWorkingMinutes = data;
          return false;
        },
        function(error) {
          console.error(error);
        },
      );
  };
  vm.fillHomeWorkingMinutes = function() {
    return vm.updateHomeWorkingMinutes(vm.expectedWorkingMinutes);
  };

  vm.setTaskStatus = status => {
    if (!status) return;
    if (angular.isArray(status)) {
      status.forEach(vm.setTaskStatus);
      return;
    }
    if (!status.id) return;
    vm.taskStatusCache[status.id] = status;
  };

  vm.retrieveTaskStatus = (reload = false, taskId = null) => {
    let taskIds = vm.registrations.map(x => x.getPlannedTaskId()).filter(x => !!x);
    if (!taskIds || taskIds.length === 0) return;
    if (!reload) {
      taskIds = taskIds.filter(x => !vm.taskStatusCache[x]);
    }
    if (taskId) taskIds.push(taskId);
    if (!taskIds || taskIds.length === 0) return;

    return $http.post(appUrls.tasks + '/api/PlannedTasks/GetStatus', taskIds).then(
      function({ data }) {
        if (!data || !data.length) return;
        vm.setTaskStatus(data);
      },
      function(error) {
        console.error(error);
      },
    );
  };

  vm.toggleDetails = function() {
    vm.displayDetails = !vm.displayDetails;
    localStorageService.set(displayDetailsStorageKey, vm.displayDetails);
  };
}
